import { Box, Icon } from '@chaser/components';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import CheckIcon from '../../../../assets/alert-icons/success.svg';

import Logo from '../../../../components/Logo';
import { askRecoverPassword, resetRecoverPassword } from '../../duck/actions/recover-password';
import style from './RecoverPasswordForm.module.scss';

const RecoverPasswordForm = ({ error = undefined, askRecoverPassword, resetRecoverPassword, emailSent: propEmailSent = false }) => {
  const [email, setEmail] = React.useState('');
  const [emailFocussed, setEmailFocussed] = React.useState(false);
  const [emailSent, setEmailSent] = React.useState(false);

  const getErrorStyle = () => ({
    border: '2px solid #EB5757',
    borderRadius: '6px',
  });

  const getFocussedStyle = () => ({
    border: '2px solid #0B7BBC',
    borderRadius: '6px',
  });

  React.useEffect(() => {
    resetRecoverPassword();
  }, [resetRecoverPassword]);

  React.useEffect(() => {
    if (propEmailSent) {
      setEmailSent(propEmailSent);
    }
  }, [propEmailSent]);

  const getEmailInlineStyle = () => {
    return emailFocussed ? getFocussedStyle() : {};
  };

  const handleSubmit = e => {
    e.preventDefault();
    askRecoverPassword(email);
  };

  const emailInlineStyle = getEmailInlineStyle();

  return (
    <form onSubmit={handleSubmit}>
      <div className={style.recoverPasswordFormHead}>
        <Logo />
      </div>
      <Box py="large" px={['small', 'large']} className={style.recoverPasswordFormBody}>
        {email && emailSent && (
          <>
            <img alt="" className={style.recoverPasswordFormCheckIcon} src={CheckIcon} />
            <h2 className={style.recoverPasswordFormCheckTitle}>Please check your inbox</h2>
            <p className={style.recoverPasswordFormUserEmail}>{email}</p>
          </>
        )}
        {!emailSent && (
          <>
            <h2 className={style.recoverPasswordFormTitle}>Forgot password</h2>
            {error && <div className={style.loginErrorMessage}>{error}</div>}
            <div className={style.recoverPasswordFormInputBlock} style={emailInlineStyle}>
              <label className={style.recoverPasswordFormLabel} htmlFor="email" required>
                <Icon name="email" />
              </label>
              <input
                className={style.recoverPasswordFormInput}
                data-testid="forgot-password-input"
                data-trackingid="forgot-password-input"
                type="email"
                pattern=".+@.+\..+"
                placeholder="Enter your email address"
                value={email}
                onChange={e => setEmail(e.target?.value || '')}
                onFocus={() => setEmailFocussed(true)}
                onBlur={() => setEmailFocussed(false)}
              />
            </div>
            <button
              data-testid="reset-password-btn"
              data-trackingid="reset-password-btn"
              type="submit"
              className={style.recoverPasswordFormButtonSubmit}
            >
              Send password reset link
            </button>
          </>
        )}
        <div className={style.recoverPasswordFormHorizontalDivision} />
        <Link to="/login" className={style.forgotPasswordLink}>
          Back to login
        </Link>
      </Box>
    </form>
  );
};

RecoverPasswordForm.propTypes = {
  error: PropTypes.string,
  emailSent: PropTypes.bool,
  askRecoverPassword: PropTypes.func.isRequired,
  resetRecoverPassword: PropTypes.func.isRequired,
};

const mapStateToProps = ({ recoverPasswordReducer }) => ({
  emailSent: recoverPasswordReducer.emailSent,
  error: recoverPasswordReducer.error,
});

export default withRouter(
  connect(mapStateToProps, { askRecoverPassword, resetRecoverPassword })(RecoverPasswordForm),
);
